import { render, staticRenderFns } from "./VatSetupFilter.vue?vue&type=template&id=7a67e53a&scoped=true&"
import script from "./VatSetupFilter.vue?vue&type=script&lang=js&"
export * from "./VatSetupFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a67e53a",
  null
  
)

export default component.exports